import dataService from 'services/dataService';
import helper from './actionHelper';


export const searchTravelDetails = searchObj => {
  return helper.dispatchAsyncAction(async () => {
    let travelDetails = await dataService.searchTravelAdvices(searchObj);
    return travelDetails;
  }, null);
};

export const saveItinerary = id => {
  return helper.dispatchAsyncAction(async () => {
    let itinerary = await dataService.saveItinerary(id);
    return itinerary;
  }, null);
};

export const getItineraries = () => {
  return helper.dispatchAsyncAction(async () => {
    let trips = await dataService.getItineraries();
    return trips;
  }, null);
};

export const loadCovidStatistics = (countryCode, limit = 10) => {
  return helper.dispatchAsyncAction(async () => {
    let travelDetails = await dataService.searchStatistics(countryCode, limit);
    return travelDetails;
  }, null);
};
